//Helpers
import { isValidActionToken, validateLocalActionValue } from '../validation/webhook_validation_helpers';
import { bluTrvDefaultValue } from 'src/helpers/actions/local/devices/trv_local_actions';
//Types
import type { Device } from 'src/types/Device';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const setURLParamsG1 = (action: ActionJob, ip: string): string => {
	if (/^trv.(target|boost|position|ext_t)$/.test(action?.method)) {
		if (action.method == 'trv.ext_t') {
			return `http://${ip}/ext_t?temp=${action.params.ext_C}`;
		} else if (action.method == 'trv.boost') {
			return `http://${ip}/thermostat/0?boost_minutes=${action.params.duration}`;
		} else if (action.method == 'trv.position') {
			return `http://${ip}/thermostat/0?pos=${action.params.pos}`;
		} else if (action.method == 'trv.target') {
			return `http://${ip}/settings/thermostat/0?target_t_enabled=1&target_t=${action.params.target_C}`;
		}
	}
	let mode = 'relay';
	const method = (action?.method || '').toLowerCase();
	if (/rgb/i.test(method)) {
		mode = 'color';
	} else if (/light/i.test(method)) {
		mode = 'light';
	} else if (/cover/i.test(method)) {
		mode = 'roller';
	}
	let url = `http://${ip}/${mode}/${action.params.id || 0}?`;
	if (/^(switch|light)\.toggle$/i.test(method)) {
		url += `&turn=toggle`;
	} else if (/^(cover)\.(open|close)$/i.test(method)) {
		url += `&go=${method.split('.')[1]}`;
	} else {
		for (let k in action.params) {
			let p = action.params[k];
			if (k == 'id' || p == null) continue;
			else if (k == 'on') {
				k = 'turn';
				p = action.params.on ? 'on' : 'off';
			} else if (k == 'toggle_after') {
				k = mode == 'roller' ? 'duration' : 'timer';
			} else if (k == 'ct') {
				k = 'temp';
			} else if (k == 'brightness' && mode == 'color') {
				k = 'gain';
			}
			if (k == 'pos' && mode == 'roller') {
				url += `&go=to_pos&roller_pos=${p}`;
			} else if (k == 'rgb' && /^(color|light)$/.test(mode)) {
				const c = Array.isArray(p) ? p : p.split(',');
				url += `&red=${c[0]}&green=${c[1]}&blue=${c[2]}`;
			} else if (!/(rgb|pos)/.test(k)) {
				url += `&${k}=${p}`;
			}
		}
	}
	return encodeURI(url.replace('?&', '?'));
};

export const getMinBrightnessByDevice = (device: Device): number => {
	return device.type == 'SHDM-2' || (device.type == 'SHRGBW2' && device?.mode != 'color') ? 1 : 0;
};

export const getURLWebhookParamsTRVG1 = (url: string, decodeURL: Function): ActionJob => {
	const match = decodeURL(url).match(
		/\d\/(ext_t\?temp=|thermostat\/0\?pos=|thermostat\/0\?boost_minutes=|settings\/thermostat\/0\?(target_t_enabled=1&)?target_t=)(.*)$/i,
	);
	let method = 'target';
	let param = 'target_C';
	if (/pos=/.test(match?.[1])) {
		method = 'position';
		param = 'pos';
	} else if (/boost/.test(match?.[1])) {
		method = 'boost';
		param = 'duration';
	} else if (/temp/.test(match?.[1])) {
		method = 'ext_t';
		param = 'ext_C';
	}
	const value = match?.[3];
	const validateValue = (method: string, value: any): boolean => {
		switch (method) {
			case 'target':
				return validateLocalActionValue(value, 4, 31);
			case 'ext_t':
				return validateLocalActionValue(value, -10, 10);
			case 'boost':
				return validateLocalActionValue(value, 5, 1440);
			case 'position':
				return validateLocalActionValue(value, 0, 100);
		}
		return true;
	};
	return {
		method: `trv.${method}`,
		params: {
			id: 0,
			[`${param}`]: isValidActionToken(value)
				? value
				: (Number(value) ?? bluTrvDefaultValue(method)),
		},
		error: match == null || validateValue(method, value),
	};
};
